import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoHappyFace = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 34 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>HappyFace</title>
    <circle
      cx={17.002}
      cy={16.999}
      r={11.718}
      transform="rotate(180 17.002 16.999)"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.303 19.3c.99 2.588 3.612 4.438 6.691 4.438 3.09 0 5.718-1.862 6.701-4.464"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.651 16.41c.616 0 1.116-1 1.116-2.232 0-1.233-.5-2.232-1.116-2.232-.616 0-1.116 1-1.116 2.232 0 1.232.5 2.231 1.116 2.231ZM20.347 16.41c.616 0 1.115-1 1.115-2.232 0-1.233-.5-2.232-1.115-2.232-.617 0-1.116 1-1.116 2.232 0 1.232.5 2.231 1.116 2.231Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIcoHappyFace;
